import axios from "axios";

import ENV from "../../../util/env-config";
import { getSessionCookie } from "../../../util/common";

class Service {
  static requestConfig() {
    return {
      headers: {
        Authorization: `Bearer ${getSessionCookie()}`,
      },
    };
  }

  static listQueryHistory(requestData) {
    return axios.post(ENV.dmsWeb + "/custom_queries/list", requestData, this.requestConfig());
  }

  static submitQuery(requestData) {
    return axios.post(ENV.dmsWeb + "/custom_queries/submit", requestData, this.requestConfig());
  }
}

export default Service;
